/**
 * Editorial Contentful button text wins over the dictionary label.
 */
export function resolvePaywallSubmitLabel(options: {
  buttonText?: string | null;
  dictionaryLabel?: string | null;
  fallback: string;
}): string {
  const editorial = options.buttonText?.trim();
  if (editorial) {
    return editorial;
  }

  const dictionaryLabel = options.dictionaryLabel?.trim();
  if (dictionaryLabel) {
    return dictionaryLabel;
  }

  return options.fallback;
}
